import { groupSectionEntityName } from '../../../../backend/config/classifiers/GroupSectionClassifier/shared';
import { ContactManagementConfigContext } from '../../../../ui/providers';
import { useAnonymousStorageList } from '@juvare/platform-sdk-react/ui/hooks';
import React from 'react';
// TODO rename to useGroupSections, delete old hook
export function useGroupSectionsNew() {
    const { appName } = React.useContext(ContactManagementConfigContext);
    const response = useAnonymousStorageList(groupSectionEntityName, {
        filter: [{ column: 'status', op: '=', value: 'active' }],
        orderBy: [{ column: 'displayOrder' }, { column: 'name' }],
    }, appName);
    return Object.assign(Object.assign({}, response), { data: response.data
            ? {
                rows: response.data.rows,
                filteredRowCount: response.data.total,
            }
            : undefined, reload: response.mutate });
}
